export const DICTIONARY_URL =
  "https://api.dictionaryapi.dev/api/v2/entries/en/";
export const WORD_SEARCH_URL = "https://api.datamuse.com/sug";
export const MAX_RESULTS_TO_RETURN = 7;
